import { Directive, ElementRef, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { RouteValidationService } from 'apps/wsg/src/app/authorization/route-validation.service';

@Directive({
  selector: '[validateRoute]'
})
export class ValidateRouteDirective {

  route: string;

  @Input()
  set validateRoute(path) {
    this.route = path;

    if (this.routeValidationService.validateRoute(path)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  constructor(private element: ElementRef,
              private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private routeValidationService: RouteValidationService) { }


  validateUrl(url) {
    return this.routeValidationService.validateRoute(url);
  }
}
